import { Box } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ImpersonateAppHandoffStatus } from './ImpersonateAppHandoffStatus';
import { useAppHandoffRedeem } from './useAppHandoffRedeem';

const CONTAINER_SX = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 3,
  py: 6,
  px: 3,
  maxWidth: 420,
  mx: 'auto',
  textAlign: 'center',
} as const;

/**
 * Landing page for the web-admin -> mobile-app impersonation handoff QR / link.
 * The phone that opens this must be signed in to the admin site as the same
 * admin who generated the handoff; the backend enforces that (actor_sub match)
 * and only then returns the app deep link.
 */
export default function ImpersonateAppHandoff() {
  const [params] = useSearchParams();
  const status = useAppHandoffRedeem(params.get('ht'));

  return (
    <Box sx={CONTAINER_SX}>
      <ImpersonateAppHandoffStatus status={status} />
    </Box>
  );
}
